import { render, staticRenderFns } from "./PasswordSetup.vue?vue&type=template&id=29f7c886&scoped=true&"
import script from "./PasswordSetup.vue?vue&type=script&lang=js&"
export * from "./PasswordSetup.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSetup.vue?vue&type=style&index=0&id=29f7c886&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f7c886",
  null
  
)

export default component.exports